<template>
  <v-container fluid>
    <v-snackbar
      v-model="snackbar"
      :color="snackbarColor"
      :top="true"
      :right="true"
      :timeout="-1"
      absolute
    >
      {{ message }}
      <v-btn
        dark
        text
        @click="snackbar = false"
      >
        CLOSE
      </v-btn>
    </v-snackbar>
    <v-row>
      <v-spacer></v-spacer>
      <v-col cols="3" v-if="canCreateRate">
        <v-btn color="#7BC243" @click="openCreateDialog" class="white--text cataloguebtn">Create Rate </v-btn>
      </v-col>
    </v-row>
    <v-layout class="main-layout">
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <h2> CCARF RATE </h2>
            <h3 v-if="userId"></h3>
            <v-spacer></v-spacer>
            <!--        <v-btn @click="createRateDialog=true" color="primary" v-if="ratesCount <= 0 && $can('CAN_CREATE_CHERRY_RATE')"> Update Rate </v-btn>-->
          </v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="rates"
              :items-per-page="5"
              class="elevation-1"
            >
              <template v-slot:item.actions="{ item }">
                <v-btn class="btn" v-if="canCreateRate && item['status']['statusName'] == 'PENDING_APPROVAL'" @click="editRate(item)" color="primary"> Edit </v-btn>
                <!--            <v-btn class="btn" v-if="canApproveMillingChargeOnSettlement && item['status']['statusName'] == 'PENDING-APPROVAL'" @click="approveRejectRateShowDialog(item)" color="primary"> Approve </v-btn>-->
                <v-menu offset-y v-if="canUpdateRate && item['status']['statusName'] == 'PENDING_APPROVAL'">
                  <template v-slot:activator="{ on }">
                    <v-btn
                      color="primary"
                      v-on="on"
                      text
                      icon
                      
                    >
                      <v-icon small> more_horiz </v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="approveRejectRateShowDialog(item, 1)"> Approve </v-list-item-title>
                    </v-list-item>
                    <v-list-item>
                      <v-list-item-title style="cursor: pointer" @click="approveRejectRateShowDialog(item, 0)"> Reject </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-flex>

      <v-dialog v-model="rateLimitDialog" persistent max-width="500">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text">Create Rate</v-card-title>
            <v-card-text>
              <form ref="uploadRate">
                <v-select
                  label="Borrower Type"
                  item-text="name"
                  item-value="value"
                  v-model="defaultSelectedBorrower"
                  :items="borrowerType"
                  variant="solo-filled"
                  v-on:change="borrowerTypeOnSelect"></v-select>
                <label class="custom-form-error borrower-error" for="contract"></label>

                <v-select
                  label="Coffee Type"
                  item-text="name"
                  item-value="value"
                  v-model="defaultSelectedCoffee"
                  :items="coffeeType"
                  variant="solo-filled"
                  v-on:change="coffeeTypeOnSelect"></v-select>
                <label class="custom-form-error coffee-type-error" for="contract"></label>
                <v-select
                  label="Grade"
                  item-text="name"
                  item-value="value"
                  v-model="defaultSelectedGrade"
                  :items="gradeType"
                  :disabled="gradeDisabled"
                  variant="solo-filled"
                ></v-select>
                <label class="custom-form-error grade-error" for="contract"></label>

                <v-text-field label="Rate/KG" min="1" type="number" v-model="rate_amount"></v-text-field>
                <label class="custom-form-error rate-error" for="contract"></label>

              </form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="rateLimitDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary"  @click="createRate">Submit</v-btn>
              <v-progress-circular v-show="approveloading || declineloading" color="red" size="20" indeterminate ></v-progress-circular>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog v-model="editRateLimitDialog" persistent max-width="500">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text">Update Rate</v-card-title>
            <v-card-text>
              <form>
                <v-select
                  label="Borrower Type"
                  item-text="name"
                  item-value="value"
                  v-model="editFarmerType"
                  :items="borrowerType"
                  variant="solo-filled"
                  v-on:change="borrowerTypeOnSelectEdit"></v-select>
                <label class="custom-form-error borrower-error" for="contract"></label>              <v-select
                label="Coffee Type"
                item-text="name"
                item-value="value"
                v-model="editCoffeeType"
                :items="coffeeType"
                variant="solo-filled"
                v-on:change="coffeeTypeOnSelectEdit"></v-select>
                <label class="custom-form-error coffee-type-error" for="contract"></label>
                <v-select
                  label="Grade"
                  item-text="name"
                  item-value="value"
                  v-model="editGrade"
                  :items="gradeTypeEdit"
                  variant="solo-filled"
                ></v-select>
                <label class="custom-form-error grade-error" for="contract"></label>
                <v-text-field label="Rate/KG" min="1" type="number" v-model="rate_amount_edit"></v-text-field>
                <label class="custom-form-error rate-error" for="contract"></label>
              </form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="editRateLimitDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="secondary"  @click="updateRate">Submit</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>

      <v-dialog v-model="approveRateLimitDialog" persistent max-width="500">
        <template>
          <v-card>
            <v-card-title class="headline accent&#45;&#45;text">CCARF Rate</v-card-title>
            <v-card-text v-if="approveStatus === 1"> Do you want to approve the rate?</v-card-text>
            <v-card-text v-if="approveStatus === 0"> Do you want to reject the rate?</v-card-text>
            <v-card-actions>
              <v-btn color="white" class="accentd&#45;&#45;text" style="font-weight: 700;"  @click="approveRateLimitDialog = false">Cancel</v-btn>
              <v-spacer></v-spacer>
              <v-btn v-if="approveStatus === 1" color="secondary"  @click="approveRate">Approve</v-btn>
              <v-btn v-if="approveStatus === 0" color="secondary"  @click="approveRate">Reject</v-btn>
            </v-card-actions>
          </v-card>
        </template>
      </v-dialog>
    </v-layout>
  </v-container>
</template>
<script>
import axios from 'axios'
import config from '../../../config'
import store from '../../../store'
import http from '../../../http'
import { mapState } from 'vuex'

export default {
  name: 'catalogueupload',
  data: function () {
    return {
      gradeDisabled: true,
      defaultSelectedBorrower: {
        name: 'FCS',
        value: 'FCS'
      },
      defaultSelectedCoffee: {
        name: 'CHERRY',
        value: 'CHERRY'
      },
      defaultSelectedGrade: {
        name: 'None',
        value: 'None'
      },
      borrowerType: [
        {
          name: 'FCS',
          value: 'FCS'
        },
        {
          name: 'FCS FARMER',
          value: 'FCS_FARMER'
        },
        {
          name: 'ESTATE FARMER',
          value: 'ESTATE_FARMER'
        }
      ],
      coffeeType: [
        {
          name: 'CHERRY',
          value: 'CHERRY'
        },
        {
          name: 'PARCHMENT',
          value: 'PARCHMENT'
        },
        // {
        //   name: 'CLEAN COFFEE',
        //   value: 'CLEAN COFFEE'
        // }
      ],
      gradeType: [{
        name: 'None',
        value: 'None'
      }],
      gradeTypeEdit: [],
      gradeTypeCherry: [{
        name: 'None',
        value: 'None'
      }],
      gradeTypeParchment: [{
        name: 'P1',
        value: 'P1'
      },
        {
          name: 'P2',
          value: 'P2'
        },
        {
          name: 'P3',
          value: 'P3'
        },
        {
          name: 'PL',
          value: 'PL'
        }],
      gradeTypeCleanCoffee: [{
        name: 'AA',
        value: 'AA'
      },
        {
          name: 'BB',
          value: 'BB'
        },
        {
          name: 'C',
          value: 'C'
        }],
      rates: [],
      editFarmerType: {},
      editCoffeeType: {},
      editGrade: {},
      editStatus: '',
      cherryRateTemp: {
        rate: 0,
        name: 'hello'
      },
      headers: [
        {
          text: 'Borrower',
          value: 'farmerType.name'
        },
        {
          text: 'Coffee',
          value: 'coffeType.type'
        },
        {
          text: 'Rate',
          value: 'rate'
        },
        {
          text: 'Grade',
          value: 'grade'
        },
        {
          text: 'Status',
          value: 'status.statusName'
        },
        {
          text: 'Actions',
          value: 'actions',
          sortable: false
        }
      ],
      borrower_type: '',
      coffee_type: '',
      grade: '',
      rate_amount: '',
      rate_amount_edit: '',
      rate_edit_id: '',
      valid: true,
      message: '',
      snackbar: false,
      snackbarColor: '',
      file: '',
      files: [],
      approveStatus: 0,
      pagination: {
        sortBy: 'id',
        descending: true
      },
      search: '',
      permissions: [],
      previewLoading: false,
      approveloading: false,
      declineloading: false,
      paginatedFiles: [],
      numberOfLinks: 0,
      numberOfItemsPerPage: 7,
      page: 1,
      confirmDialog: false,
      confirmFile: {},
      confirmMessage: '',
      action: '',
      rateLimitDialog: false,
      editRateLimitDialog: false,
      approveRateLimitDialog: false,
      userID: 0
    }
  },
  mounted () {
    this.getRates()
    this.permissions = store.state.user.roleId.permissions
  },
  watch: {
    files () {
      this.paginatedFiles = this.paginationMethod(this.files, 1, this.numberOfItemsPerPage)
      this.numberOfLinks = Math.ceil(this.files.length / this.numberOfItemsPerPage)
    },
    page: function (val) {
      this.paginatedFiles = this.paginationMethod(this.files, val, this.numberOfItemsPerPage)
    }
  },
  computed: {
    ...mapState({ user: state => state.user }),
    canUploadFarmers: function () {
      return this.hasPerm('CAN_UPLOAD_FARMERS')
    },
    canCreateRate: function () {
      return this.hasPerm('CAN_CREATE_CCARF_RATE')
    },
    canUpdateRate: function () {
      return this.hasPerm('CAN_UPDATE_CCARF_RATE')
    },
    canApproveCatalogue: function () {
      return this.hasPerm('CAN_APPROVE_CATALOGUE')
    },
    filteredList: function () {
      if (this.search === '') {
        return this.paginatedFiles
      } else {
        return this.files.filter(file => {
          return file.fileName.toLowerCase().includes(this.search.toLowerCase())
        })
      }
    },
    userId: function () {
      if (this.user) {
        this.userID = this.user.id
        return this.user.id
      }
      return 0
    }
  },
  methods: {
    borrowerTypeOnSelect (e) {
      console.log('f -> ', e)
      this.coffeeType = [{
          name: 'CHERRY',
          value: 'CHERRY'
        },{
          name: 'PARCHMENT',
          value: 'PARCHMENT'
        }]
      // if (e === 'ESTATE_FARMER') {
      //   this.defaultSelectedCoffee = 'PARCHMENT'
      //   this.coffeeType = [{
      //     name: 'PARCHMENT',
      //     value: 'PARCHMENT'
      //   }]
      //   this.defaultSelectedGrade = { name: 'P1', value: 'P1' }
      //   this.gradeDisabled = false
      //   this.gradeType = this.gradeTypeParchment
      // } else if (e === 'FCS_FARMER') {
      //   this.defaultSelectedCoffee = 'CHERRY'
      //   this.coffeeType = [{
      //     name: 'CHERRY',
      //     value: 'CHERRY'
      //   }]
      //   this.defaultSelectedGrade = { name: 'None', value: 'None' }
      //   this.gradeDisabled = true
      //   this.gradeType = this.gradeTypeCherry
      // } else {
      //   //this.defaultSelectedCoffee = 'CHERRY'
      //   this.coffeeType = [{
      //     name: 'CHERRY',
      //     value: 'CHERRY'
      //   },{
      //     name: 'PARCHMENT',
      //     value: 'PARCHMENT'
      //   }]
      // }

    },
    borrowerTypeOnSelectEdit(e){
      console.log('fg -> ', e)
      this.coffeeType = [{
          name: 'CHERRY',
          value: 'CHERRY'
        },{
          name: 'PARCHMENT',
          value: 'PARCHMENT'
        }]
      // if (e === 'ESTATE_FARMER') {
      //   this.editCoffeeType = 'PARCHMENT'
      //   this.coffeeType = [{
      //     name: 'PARCHMENT',
      //     value: 'PARCHMENT'
      //   }
      // ]
      //   this.editGrade = { name: 'P1', value: 'P1' }
      //   this.gradeDisabled = false
      //   this.gradeTypeEdit = this.gradeTypeParchment
      // } else
      //  if (e === 'ESTATE_FARMER') {
      //   this.editCoffeeType = 'CHERRY'
      //   this.coffeeType = [{
      //     name: 'CHERRY',
      //     value: 'CHERRY'
      //   }]
      //   this.editGrade = { name: 'None', value: 'None' }
      //   this.gradeDisabled = true
      //   this.gradeTypeEdit = this.gradeTypeCherry
      // } else {
      //   this.coffeeType = [{
      //     name: 'CHERRY',
      //     value: 'CHERRY'
      //   },{
      //     name: 'PARCHMENT',
      //     value: 'PARCHMENT'
      //   }]
      // }
    },
    coffeeTypeOnSelect (e) {
      console.log('e -> ', e)
      if (e !== 'CHERRY') {
        this.gradeDisabled = false

        if (e === 'PARCHMENT') {
          this.defaultSelectedGrade = {
            name: 'P1',
            value: 'P1'
          }
          this.gradeType = this.gradeTypeParchment
        } else if (e === 'CLEAN COFFEE') {
          this.defaultSelectedGrade = {
            name: 'AA',
            value: 'AA'
          }
          this.gradeType = this.gradeTypeCleanCoffee
        }
      } else {
        this.defaultSelectedGrade = {
          name: 'None',
          value: 'None'
        }
        this.gradeType = this.gradeTypeCherry
        this.gradeDisabled = true
      }
    },
    coffeeTypeOnSelectEdit (e) {
      console.log('e -> ', e)
      if (e !== 'CHERRY') {
        this.gradeDisabled = false

        if (e === 'PARCHMENT') {
          this.editGrade = {
            name: 'P1',
            value: 'P1'
          }
          this.gradeTypeEdit = this.gradeTypeParchment
        } else if (e === 'CLEAN COFFEE') {
          this.editGrade = {
            name: 'AA',
            value: 'AA'
          }
          this.gradeTypeEdit = this.gradeTypeCleanCoffee
        }
      } else {
        this.editGrade = {
          name: 'None',
          value: 'None'
        }
        this.gradeTypeEdit = this.gradeTypeCherry
      }
    },
    canBeApproved (item) {
      return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
    },
    canBeDeclined (item) {
      return item.status.id === 3 && this.hasPerm('CAN_APPROVE_FARMERS')
    },
    paginationMethod (items, pageNumber, limitPerPage) {
      pageNumber = pageNumber - 1
      const from = pageNumber * limitPerPage
      let to = (pageNumber + 1) * limitPerPage
      if (to >= items.length) {
        to = items.length
      }
      return items.slice(from, to)
    },
    hasPerm (permission) {
      return this.permissions.includes(permission)
    },
    handleFileUpload () {
      this.file = this.$refs.file.files[0]
    },
    openCreateDialog () {
      $('.custom-form-error').css('display', 'none')
      console.log('oopppppp')
      this.rateLimitDialog = true
    },
    createRate () {
      let borrowerType = this.defaultSelectedBorrower.value
      let coffeeType = this.defaultSelectedCoffee.value
      let grade = this.defaultSelectedGrade.value

      // const coffeeType = this.coffee_type;
      // const grade = this.grade;
      const rateAmount = this.rate_amount

      if (borrowerType === undefined) {
        borrowerType = this.defaultSelectedBorrower
      }
      if (coffeeType === undefined) {
        coffeeType = this.defaultSelectedCoffee
      }
      if (grade === undefined) {
        grade = this.defaultSelectedGrade
      }

      console.log(borrowerType, coffeeType, grade, rateAmount)

      $('.custom-form-error').css('display', 'none')

      if (borrowerType === '') {
        $('.borrower-error').css('display', 'inline')
        $('.borrower-error').text('Please select the borrower type')
        return
      }

      if (coffeeType === '') {
        $('.coffee-type-error').css('display', 'inline')
        $('.coffee-type-error').text('Please select the coffee type')
        return
      }

      if (grade === '') {
        $('.grade-error').css('display', 'inline')
        $('.grade-error').text('Please select the grade')
        return
      }

      if (rateAmount === '') {
        $('.rate-error').css('display', 'inline')
        $('.rate-error').text('Please enter the rate')
        return
      }

      $('.custom-form-error').css('display', 'none')
      console.log("hooray")
      // return;
      this.approveloading = true
      // var url = config.serverURI + '/limit/rate?userId=' + this.userID + '&status=PENDING-APPROVAL&borrowerType=' + borrowerType + '&coffeeType=' + coffeeType + '&grade=' + grade + '&rateAmount=' + rateAmount
      var url = config.serverURI + '/limit/rate'
      const data = {
        borrowerType: borrowerType,
        coffeeType: coffeeType,
        grade: grade,
        rateAmount: rateAmount
      }
      axios
        // .post(url, {})
        .post(url, data)
        // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
        // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
        .then(response => {
          var data = response.data
          var checkError = data.error
          this.rateLimitDialog = false
          console.log('checkError ', checkError)

          this.approveloading = false
          if (checkError !== undefined && checkError === true) {
            this.message = data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            return
          }
          // this.$refs.uploadRate.reset()
          this.defaultSelectedBorrower = 'FCS'
          this.defaultSelectedCoffee = 'CHERRY'
          this.defaultSelectedGrade = {
            name: 'None',
            value: 'None'
          }
          this.gradeType = this.gradeTypeCherry
          this.gradeDisabled = true
          this.rate_amount = ''

          this.message = 'Successfully added rate'
          this.snackbar = true
          this.snackbarColor = 'primary'
          this.getRates()
        })
        .catch(error => {
          if (error.response.status === 400) {
            this.message = error.response.data.message
          } else {
            this.message = 'Something went wrong, please try again'
          }
          this.approveloading = false
          this.rateLimitDialog = false
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },

    approveRejectRateShowDialog (item, status) {
      $('.custom-form-error').css('display', 'none')
      console.log(item)
      console.log(status)
      this.approveStatus = status
      this.rate_edit_id = item.id
      this.approveRateLimitDialog = true
    },

    editRate (item) {
      console.log('ITM -> ', item)
      this.editRateLimitDialog = true
      this.cherryRateTemp = item
      this.editFarmerType = {
        name: item.farmerType.name,
        value: item.farmerType.name
      }
      this.editCoffeeType = {
        name: item.coffeType.type,
        value: item.coffeType.type
      }
      this.editGrade = {
        name: item.grade,
        value: item.grade
      }
      this.editStatus = item.status.statusName
      this.rate_amount_edit = item.rate
      this.rate_edit_id = item.id
      if (item.farmerType.name === 'ESTATE_FARMER') {
        this.editCoffeeType = 'PARCHMENT'
        this.coffeeType = [{
          name: 'PARCHMENT',
          value: 'PARCHMENT'
        }]
        this.defaultSelectedGrade = { name: 'P1', value: 'P1' }
        this.gradeDisabled = false
        this.gradeTypeEdit = this.gradeTypeParchment
      } else {
        this.coffeeType = [{
          name: 'CHERRY',
          value: 'CHERRY'
        },{
          name: 'PARCHMENT',
          value: 'PARCHMENT'
        }]
      }
      if (item.coffeType.type === 'CHERRY') {
        this.gradeTypeEdit = this.gradeTypeCherry
      } else if (item.coffeType.type === 'PARCHMENT') {
        this.gradeTypeEdit = this.gradeTypeParchment
      } else if (item.coffeType.type === 'CLEAN COFFEE') {
        this.gradeTypeEdit = this.gradeTypeCleanCoffee
      }
    },
    getRates () {
      http.get(config.serverURI + '/limit/ratesFindByStatus')
        .then(response => {
          this.rates = response.data
        })
        .catch(error => {
          console.log('error', error)
          this.$store.dispatch('alert/displayAlert', {
            snackbar: true,
            color: 'error',
            message: error.response ? error.response.data.message : 'Error ocurred'
          }, { root: true })
        })
    },
    updateRate () {
      let borrowerType = this.editFarmerType.value
      let coffeeType = this.editCoffeeType.value
      let grade = this.editGrade.value

      // const coffeeType = this.coffee_type;
      // const grade = this.grade;
      const rateAmount = this.rate_amount_edit
      const rateId = this.rate_edit_id

      if (borrowerType === undefined) {
        borrowerType = this.editFarmerType
      }
      if (coffeeType === undefined) {
        coffeeType = this.editCoffeeType
      }
      if (grade === undefined) {
        grade = this.editGrade
      }

      console.log('--> ', rateId, borrowerType, coffeeType, grade, rateAmount)
      // return;
      $('.custom-form-error').css('display', 'none')
      if (borrowerType === '') {
        $('.borrower-error').css('display', 'inline')
        $('.borrower-error').text('Please select the borrower type')
        return
      }

      if (coffeeType === '') {
        $('.coffee-type-error').css('display', 'inline')
        $('.coffee-type-error').text('Please select the coffee type')
        return
      }

      if (grade === '') {
        $('.grade-error').css('display', 'inline')
        $('.grade-error').text('Please select the grade')
        return
      }

      if (rateAmount === '') {
        $('.rate-error').css('display', 'inline')
        $('.rate-error').text('Please enter the rate')
        return
      }

      $('.custom-form-error').css('display', 'none')
      const data = {
        rateId: rateId,
        borrowerType: borrowerType,
        coffeeType: coffeeType,
        grade: grade,
        rateAmount: rateAmount
      }

      // var url = config.serverURI + '/limit/rate?userId=' + this.userID + '&rateId=' + rateId + '&status=PENDING-APPROVAL&borrowerType=' + borrowerType + '&coffeeType=' + coffeeType + '&grade=' + grade + '&rateAmount=' + rateAmount
      var url = config.serverURI + '/limit/rate/' + rateId
      axios
        .put(url, data)
        // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
        // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
        .then(response => {
          var data = response.data
          var checkError = data.error
          this.editRateLimitDialog = false
          console.log('checkError ', checkError)
          if (checkError !== undefined && checkError === true) {
            this.message = data.message
            this.snackbar = true
            this.snackbarColor = 'error'
            return
          }
          this.message = 'Successfully edited rate'
          this.snackbar = true
          this.snackbarColor = 'primary'
          this.getRates()
        })
        .catch(error => {
          this.editRateLimitDialog = false
          this.message = 'Something went wrong, please try again'
          this.snackbar = true
          this.snackbarColor = 'error'
        })
    },
    approveRate () {
      const rateId = this.rate_edit_id
      const data = {
        rateId: rateId,
        status: this.approveStatus
      }
      if (rateId !== '') {
        var url = config.serverURI + '/limit/approve'
        // var url = config.serverURI + '/limit/approve?userId=' + this.userID + '&rateId=' + rateId + '&status=' + this.approveStatus
        axios
          .put(url, data)
          // .post(url, {params: { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount }})
          // .post(url, { borrowerType: borrowerType, coffeeType: coffeeType, grade: grade, rateAmount: rateAmount })
          .then(response => {
            var data = response.data
            var checkError = data.error
            this.approveRateLimitDialog = false
            console.log('checkError ', checkError)
            if (checkError !== undefined && checkError === true) {
              this.message = data.message
              this.snackbar = true
              this.snackbarColor = 'error'
              return
            }
            this.message = 'Your request is successful'
            this.snackbar = true
            this.snackbarColor = 'primary'
            this.getRates()
          })
          .catch(error => {
            this.approveRateLimitDialog = false
            this.message = 'Something went wrong, please try again'
            this.snackbar = true
            this.snackbarColor = 'error'
          })
      } else {
        this.message = 'Please enter all checkoffSettlementDetails'
        this.snackbar = true
        this.snackbarColor = 'error'
      }
    }
  }
}

</script>
<style>
.custom-form-error {
  display: none;
  color: red;
}

.main-layout {
  margin-top: 15px;
}

.farmers_box_empty {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.btn {
  padding: 10px;
  margin: 5px;
}

.farmers_box {
  position: relative;
  background: #fff;
  border: 1px solid #707070;
}

.thead {
  background-color: #00513B !important;
  color: white;
  font-size: 12px;
}

.table tbody tr > td.actions {
  font-size: 20px !important;
  color: #733D29 !important;
  padding-top: 0px;
}

.pagination {
  background-color: red;
}

.paginationtext {
  color: #733D29;
}

.pagination > li > a,
.pagination > li > span {
  border: 1px solid #F2D0A7;
  color: #733D29;
}

.pagination > li.active > .page-link {
  background: #00513B;
  color: #fff;
}

select {
  border: 1px solid #000;
  color: black;
  padding: 10px;
}

v-col {
  border: 1px solid brown;
}
</style>
